const HeroVariant1 = ({ theme, font, editableData = {}, renderEditable }) => {
  // Helper to get text value safely
  const getText = (key, defaultValue) => {
    const value = editableData[key];
    return typeof value === 'string' ? value : value?.text || defaultValue;
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center text-center p-8" 
         style={{ backgroundColor: theme.backgroundColor, fontFamily: font.mainText }}>
      <h1 className="text-5xl font-bold mb-6" style={{ color: theme.primaryColor }}>
        {renderEditable ? 
          renderEditable("heading", getText("heading", "Modern Web Solutions")) : 
          getText("heading", "Modern Web Solutions")
        }
      </h1>
      <p className="text-xl max-w-2xl mb-8" style={{ color: theme.textColor }}>
        {renderEditable ? 
          renderEditable("subheading", getText("subheading", "Build amazing digital experiences with our cutting-edge platform")) : 
          getText("subheading", "Build amazing digital experiences with our cutting-edge platform")
        }
      </p>
      <div className="flex gap-4">
        <button 
          className="px-6 py-3 rounded-lg font-medium transition-all"
          style={{ 
            backgroundColor: theme.primaryColor, 
            color: theme.backgroundColor
          }}
        >
          {renderEditable ? 
            renderEditable("primaryButton", getText("primaryButton", "Get Started")) : 
            getText("primaryButton", "Get Started")
          }
        </button>
        <button 
          className="px-6 py-3 rounded-lg font-medium border-2 transition-all"
          style={{ 
            borderColor: theme.primaryColor, 
            color: theme.primaryColor 
          }}
        >
          {renderEditable ? 
            renderEditable("secondaryButton", getText("secondaryButton", "Live Demo")) : 
            getText("secondaryButton", "Live Demo")
          }
        </button>
      </div>
    </div>
  );
};

export default HeroVariant1;